<router-outlet></router-outlet>
<app-latest-version></app-latest-version>
